import { Route, Routes } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Suspense, lazy } from "react";
import Loader from "../../assets/loader.gif";
import discountIcon from "../../assets/icons/DiscountSanction.svg";
import timelineIcon from "../../assets/icons/PreOrderTimeline.svg";
import orderBookingIcon from "../../assets/icons/TransactionsGray.svg";

import DynamicSearchForm from "../Admin/DynamicSearchForm";

export default function Main() {
  return (
    <Container bsPrefix="main">
      <Routes>
        <Route
          exact
          path="/home"
          element={
            <Suspense
              fallback={
                <div className="loader-box">
                  <img src={Loader} alt="Loading" className="newloader"></img>
                </div>
              }
            >
              <DynamicSearchForm
                key="enquiry"
                title="Enquiry"
                apimethod="enquiry"
                page="AddEnquiryMaster"
              />
            </Suspense>
          }
        />
        <Route
          exact
          path="/discountsanction"
          element={
            <Suspense
              fallback={
                <div className="loader-box">
                  <img src={discountIcon} alt="Loading" className="refresh-icon"></img>
                </div>
              }
            >
              <DynamicSearchForm
                key="discountsanction"
                title="Discount Sanction"
                apimethod="discountsanction"
                page="DiscountAdd"
              />
              {/* <DiscountSanction /> */}
            </Suspense>
          }
        />
        <Route
          exact
          path="/timeline"
          element={
            <Suspense
              fallback={
                <div className="loader-box">
                  <img src={timelineIcon} alt="Loading" className="refresh-icon"></img>
                </div>
              }
            >
              <DynamicSearchForm
                key="timeline"
                title="Pre-Order Timeline"
                apimethod="timeline"
                page="AddTimelineMaster"

              />
            </Suspense>
          }
        />
        <Route
          exact
          path="/orderbooking"
          element={
            <Suspense
              fallback={
                <div className="loader-box">
                  <img src={orderBookingIcon} alt="Loading" className="refresh-icon"></img>
                </div>
              }
            >
              <DynamicSearchForm
                key="orderbooking"
                title="Order Booking"
                apimethod="orderbooking"
                page="AddOrderBooking"

              />
            </Suspense>
          }
        />
      </Routes>
    </Container>
  );
}
